<template>
  <div class="share-content" @click.stop="bindStop">
    <div class="title">分享至</div>
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <div class="icon-container">
      <div class="icon-list">
        <div
          class="icon-item"
          v-for="(item, index) in shareList"
          :key="index"
          @click="bindClickIcon(item)"
        >
          <div
            class="iconfont"
            :class="[item.icon]"
            :style="{
              color: item.disabled ? 'rgb(221,221,221)' : item.color,
              fontSize: item.fontSize,
              animationDelay: 0.3 + 0.1 * index + 's'
            }"
          ></div>
          <div>{{ item.name }}</div>
        </div>
      </div>
      <!-- <div class="icon-list">
        <div
          class="icon-item radio-item"
          v-for="(item, index) in iconList"
          :key="index"
          @click="bindClickIcon(item)"
        >
          <div
            class="iconfont radio-iconfont"
            :class="[item.icon]"
            :style="{
              color: item.color,
              fontSize: item.fontSize,
              animationDelay: 0.3 + 0.1 * index + 's',
            }"
          ></div>
          <div>{{ item.name }}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shareList: [
        {
          type: 1,
          icon: 'icon-weixin',
          color: 'rgb(73,194,101)',
          fontSize: '40px',
          name: '微信好友',
          showEnv: [0],
          disabled: true
        },
        {
          type: 2,
          icon: 'icon-pengyouquan',
          color: 'rgb(117,205,57)',
          fontSize: '40px',
          name: '朋友圈',
          showEnv: [0],
          disabled: true
        }
      ],
      iconList: [
        {
          type: 3,
          icon: 'icon-tupian2',
          color: 'rgb(66,66,66)',
          fontSize: '24px',
          name: '生成分享图',
          showEnv: [0, 1, 2],
          disabled: false
        },
        {
          type: 4,
          icon: 'icon-80',
          color: 'rgb(66,66,66)',
          fontSize: '24px',
          name: '复制链接',
          showEnv: [0, 1, 2],
          disabled: false
        }
      ],
      evList: ['app', 'miniProgram', 'h5'], //环境列表
      curEv: 0
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.$http._isApp()) {
        this.curEv = 0
        this.initIconList()
      } else {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            this.curEv = 1
          } else {
            this.curEv = 2
          }
          this.initIconList()
        })
      }
    },
    //初始化图标禁用选项
    initIconList() {
      console.log('初始化')
      this.shareList.map((item) => {
        if (item.showEnv.includes(this.curEv)) {
          item.disabled = false
        } else {
          item.disabled = true
        }
      })
      this.iconList.map((item) => {
        if (item.showEnv.includes(this.curEv)) {
          item.disabled = false
        } else {
          item.disabled = true
        }
      })
    },
    bindStop() {},
    bindClose() {
      this.$emit('close')
    },
    //点击图标
    bindClickIcon(item) {
      if (item.disabled) {
        this.$toast('请在app内转发')
        return
      }
      this.$emit('share', item.type)
    },
    //复制当前链接
    shareCurUrl() {},
    //分享页面图片
    sharePageImage() {}
  }
}
</script>
<style lang="scss" scoped>
.share-content {
  height: auto;
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 12px 20px 30px;
  box-sizing: border-box;
  width: 100%;
  background-color: rgb(246, 246, 246);
  border-radius: 20px 20px 0px 0px;
  animation: shareContent 0.3s linear;
  .close {
    padding: 12px;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 20px;
  }
  .title {
    text-align: center;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .icon-list {
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f1f1;
    margin-bottom: 10px;
    .icon-item {
      text-align: center;
      font-size: 12px;
      margin-right: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .radio-iconfont {
        background-color: #fff;
        border-radius: 50%;
        overflow: hidden;
      }
      .iconfont {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 6px;
        animation: bounceInUp 0.3s ease-in-out;
      }
    }
  }
  .icon-list:last-child {
    border-bottom: none;
  }
}
@keyframes bounceInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  70% {
    opacity: 1;
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes shareContent {
  0% {
    height: 0px;
  }
  100% {
    height: auto;
  }
}
</style>
